import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
// 引入全局指令
import GlobalDirectives from '@/directives';
// 注册全局指令
Vue.use(GlobalDirectives);
Vue.config.productionTip = false;
Vue.use(ElementUI);

axios.defaults.withCredentials = true; //意思是携带cookie信息,保持session的一致性
// axios.defaults.baseURL = 'https://miaodaokeji.com';
Vue.prototype.$axios = axios;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
